export type Message = {
  body?: string;
  header?: string;
};
